import React from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { format } from "date-fns";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import Rule from "../store/Rule";

const useStyles = makeStyles()(() => ({
  root: {
    width: "100%",
    marginTop: 8,
    marginBottom: 14,
  },
  icon: {
    color: "#7D8797",
    height: 20,
    width: 20,
  },
}));

type Props = {
  override: Rule;
};

const OverrideDateListItem: React.FC<Props> = observer(({ override }) => {
  const { classes } = useStyles();

  if (override.date == null) return null;

  const overrideDate = format(new Date(override.date), "MMMM dd yyyy");

  function renderIntervals() {
    if (override.presentIntervals.length > 0) {
      return override.presentIntervals.map((e, index) => {
        const startTime = e.startTime
          ? format(new Date(e.startTime ?? ""), "hh:mm aa")
          : "--";
        const endTime = e.endTime
          ? format(new Date(e.endTime ?? ""), "hh:mm aa")
          : "--";

        return (
          <Box
            key={index}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography variant="body1" fontWeight="600">
              {startTime}
            </Typography>
            <Typography variant="body1">-</Typography>
            <Typography variant="body1" fontWeight="600">
              {endTime}
            </Typography>
          </Box>
        );
      });
    } else {
      return <Typography>Unavailable</Typography>;
    }
  }
  return (
    <div className={classes.root}>
      <Divider light />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginTop={2}
        marginBottom={2}
      >
        <Typography variant="body1" fontWeight="600">
          {overrideDate.toString()}
        </Typography>
        <Box
          display="flex"
          flexDirection={"column"}
          justifyContent="center"
          alignItems="center"
        >
          {renderIntervals()}
        </Box>
        <IconButton onClick={() => override.remove()}>
          <DeleteOutlineIcon className={classes.icon} />
        </IconButton>
      </Box>
      <Divider light />
    </div>
  );
});

export default OverrideDateListItem;
